import React, { useCallback, useEffect, useState } from 'react';
import { bool, func } from 'prop-types';
import AnimationWrapper from 'components/AnimationWrapper/AnimationWrapper.jsx';
import {
  panelAnimationDuration, panelAnimationTransitionStyles, panelDefaultAnimationStyle,
} from './animationConfig.js';

export default PanelWrapperAnimation;

PanelWrapperAnimation.propTypes = {
  isLoudlyModeOn: bool.isRequired,
  onExited: func.isRequired,
  onHidePanel: func,
};

PanelWrapperAnimation.defaultProps = {
  isLoudlyModeOn: false,
};

PanelWrapperAnimation.displayName = 'PanelWrapperAnimation';

function PanelWrapperAnimation({
  children,
  isLoudlyModeOn,
  onExited,
  className,
  onHidePanel,
}) {
  const [show, setShow] = useState(false);

  const onClickWrapper = useCallback(
    (event) => {
      if (event.target === event.currentTarget && typeof onHidePanel === 'function') {
        onHidePanel();
      }
    },
    [onHidePanel]
  );

  useEffect(() => {
    setShow(isLoudlyModeOn);
  }, [isLoudlyModeOn]);

  return (
    <div className={className} onClick={onClickWrapper}>
      <AnimationWrapper
        show={show}
        duration={panelAnimationDuration}
        defaultStyle={panelDefaultAnimationStyle}
        transitionStyles={panelAnimationTransitionStyles}
        onExited={onExited}
      >
        {children}
      </AnimationWrapper>
    </div>
  );
}
